<template>
  <span> 
        <v-btn  @click.stop="listDialogReplacement=true;loadData()" color="white"  text icon >
            <v-icon small>{{icon}}</v-icon>
        </v-btn>               
        <v-dialog v-model="listDialogReplacement"  max-width="1000">
            <v-card class="px-7" style="background: #121212;" >
              <v-row>
                <v-col cols="12">
                  <v-card-title>
                    {{(title != null ? title : "")}} Similar Stocks
                    <v-spacer></v-spacer>
                    <v-btn color="primary" icon @click="listDialogReplacement = false">
                        <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                </v-col>
                <v-col cols="12">
                  <v-skeleton-loader v-if="!firstLoadDone" type="table"></v-skeleton-loader>
                  <v-data-table
                    v-if="firstLoadDone"
                    :headers="headers"
                    :items="listSimilar"
                    :mobile-breakpoint="0"
                    dense
                  >
                    <template v-slot:item="row">
                      <tr v-if="row.item.first" v-bind:style="'background-color: #00bfc5;'" >
                        <td>
                          <stock-menu :stock="row.item.id" :title="row.item.name" :preference="row.item.preference"></stock-menu>                   
                        </td>                                 
                        <td>{{ row.item.name }}</td>
                        <td>{{ row.item.daysToTrade }}</td>
                        <td>{{ formatPercentage(row.item.perf) }}
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-information-outline </v-icon>
                            </template>
                            <span>{{ row.item.text }}</span>
                          </v-tooltip>
                        </td>
                        <td>
                                                 
                          <v-btn-toggle
                          background-color='#e1e4ea'
                          dense
                            >
                              <v-btn small color="#233767">
                                {{ row.item.Value.substring(0,3) }} <br>
                                Value
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Momentum.substring(0,3) }} <br>
                                Mom
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Risk.substring(0,3) }} <br>
                                Low risk
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Size.substring(0,3) }} <br>
                                Small Size
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Quality.substring(0,3) }} <br>
                                Quality
                              </v-btn>                                                            
                          </v-btn-toggle>
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-information-outline </v-icon>
                            </template>
                            <span>{{ row.item.factor }}</span>
                          </v-tooltip> -->
                        </td>                        
                      </tr>
                      <tr v-else >
                        <td>
                          <stock-menu :stock="row.item.id" :title="row.item.name" :preference="row.item.preference"></stock-menu>                   
                        </td>                                 
                        <td>{{ row.item.name }}</td>
                        <td>{{ row.item.daysToTrade }}</td>
                        <td>{{ formatPercentage(row.item.perf) }}
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-information-outline </v-icon>
                            </template>
                            <span>{{ row.item.text }}</span>
                          </v-tooltip>
                        </td>
                        <td>
                          {{ row.item.factor }}
                          <v-btn-toggle
                          background-color='#e1e4ea'
                          dense
                            >
                              <v-btn small color="#233767">
                                {{ row.item.Value.substring(0,3) }} <br>
                                Value
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Momentum.substring(0,3) }} <br>
                                Mom
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Risk.substring(0,3) }} <br>
                                Low risk
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Size.substring(0,3) }} <br>
                                Small Size
                              </v-btn>
                              <v-btn small color="#233767">
                                {{ row.item.Quality.substring(0,3) }} <br>
                                Quality
                              </v-btn>                                                            
                          </v-btn-toggle>
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon dense small style="color: #e1e4ea; " v-on="on">mdi-information-outline </v-icon>
                            </template>
                            <span>{{ row.item.factor }}</span>
                          </v-tooltip> -->
                        </td>
                      </tr>                      
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-card-actions>    
                <v-spacer></v-spacer>             
                <v-btn color="primary" text @click="listDialogReplacement = false">Close</v-btn>
              </v-card-actions>
            </v-card>                
        </v-dialog>
    </span>
</template>

<script>
import { format } from "d3-format";
export default {
  name: "StockPotentialReplacement",
  props: {
    stock: String,
    title: String
  },
  components: {
    StockMenu: () => import('@/components/StockMenu')
  },  
  data() {
    return {
      listSimilar:[],
      listDialogReplacement: false,
      errorbar: false,
      firstLoadDone: false,
      icon: "mdi-layers-search-outline",
      tooltipText: "Find Similar Stocks",
      headers: [
        {
          sortable: false,
          text: '',
          align: 'left',
        },          
        {
          text: 'Name',
          align: 'left',
          value: 'name',
        },
        { text: 'Days to Trade', value: 'daysToTrade' },          
        { text: 'Performance', value: 'perf' },
        { text: 'Factor', value: 'factor', sortable: false },
      ],      
    };
  },
    // components: {
    //   StockSetPreference: () => import('@/components/SetPreferences'),
    //   StockPortfolioOwnership: () => import('@/components/StockPortfolioOwnership'),
    // },  
  methods: {
    loadData(){
      this.listDialogReplacement= true;
      this.getSimilarStocks();
    },
    formatPercentage(d) {
      return format("+0.0%")(d);
    },    
    async getSimilarStocks() {
      if (this.firstLoadDone) {
        return 1;
      }
      var self = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .get(process.env.VUE_APP_API_HOST + "/get-stock-replacements/" + self.stock, {
          headers: {
            Authorization: currentToken,
            "Content-Type": "application/json"
          }
        })
        .then(function(response) {
          self.listSimilar = response.data.similarities;
          //console.log(response.data)
          //self.ratingValue=action;
          //self.checkIconValue();
          self.buttonLoad = false;
          self.firstLoadDone=true;          
        })
        .catch(function(error) {
          self.buttonLoad = false;
          self.listSimilar =[];
          //console.log(error.response.data);          
          self.tooltipText = error.response.data.errorMessage;
          self.firstLoadDone=true;                
        });
    },    
  }
};
</script>